/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const CloseCircleSolidIcon = ({
  className,
  style,
  color = '#ADA9BB',
  size = 16,
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <circle cx="4.5" cy="4.5" r="4.5" fill={color} />
      <path
        d="M6.48827 1.91464L4.49953 3.90338L2.5108 1.91464C2.45586 1.8597 2.36686 1.8597 2.31192 1.91464L1.91417 2.31239C1.85924 2.36733 1.85924 2.45632 1.91417 2.51126L3.90291 4.5L1.91417 6.48874C1.85924 6.54368 1.85924 6.63267 1.91417 6.68761L2.31192 7.08536C2.36686 7.1403 2.45586 7.1403 2.5108 7.08536L4.49953 5.09662L6.48827 7.08536C6.54321 7.1403 6.63221 7.1403 6.68714 7.08536L7.08489 6.68761C7.13983 6.63267 7.13983 6.54368 7.08489 6.48874L5.09615 4.5L7.08489 2.51126C7.13983 2.45632 7.13983 2.36733 7.08489 2.31239L6.68714 1.91464C6.63221 1.8597 6.54321 1.8597 6.48827 1.91464Z"
        fill="white"
      />
    </svg>
  );
};
